import { AspectRatio, Image, Select, Stack, TagsInput, TextInput } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import Form from 'common/Form'
import SaleInput from 'common/inputs/SaleInput'
import SymbolInput from 'common/inputs/SymbolInput'
import NoImage from 'common/NoImage'
import { useManufacturers } from 'hooks/products'
import { EditProduct } from 'types/products'
import { productSchema } from 'types/schemas'
import { trimFormValues } from 'utils'

type Props = {
  onSubmit: (values: Omit<EditProduct, 'id'>) => void
  onCancel: () => void
  initialValues: Omit<EditProduct, 'id'>
}

export function EditProductForm({ onSubmit, onCancel, initialValues }: Props) {
  const form = useForm<Omit<EditProduct, 'id'>>({
    initialValues: initialValues,
    validate: zodResolver(productSchema),
    transformValues: trimFormValues,
  })

  const { data: manufacturers } = useManufacturers()

  return (
    <Form
      onSubmit={(values) => onSubmit({ ...values, image: values.image || null })}
      form={form}
      onCancel={onCancel}
      submitText="Edytuj produkt"
    >
      {form.getValues().image ? (
        <AspectRatio ratio={1}>
          <Image
            src={form.getValues().image}
            fallbackSrc="https://placehold.co/250x250/dee2e6/ffffff?text=Niepoprawny+link&font=roboto"
            alt="Zdjęcie produktu"
            style={{ width: '80%', height: 'auto' }}
            mb="lg"
            mx="auto"
          />
        </AspectRatio>
      ) : (
        <NoImage w="80%" mb="lg" />
      )}
      <Stack gap="xs">
        <SymbolInput
          symbolProps={form.getInputProps('symbol')}
          alternateSymbolProps={form.getInputProps('alternateSymbol')}
          display="column"
        />
        <TextInput
          label="Zdjęcie"
          description="Link do zdjęcia produktu, najlepiej zbliżenia wzoru."
          placeholder="https://abcfirany.pl/images/2705.jpg"
          {...form.getInputProps('image')}
        />
        <Select
          label="Producent"
          description="Producent produktu"
          placeholder="HAFT"
          data={manufacturers.map((manufacturer) => ({ value: manufacturer.id, label: manufacturer.name }))}
          withAsterisk
          {...form.getInputProps('manufacturerId')}
        />
        <TagsInput
          label="Dostępne rozmiary"
          description="Dostępne rozmiary u producenta. Np. 160, 250."
          placeholder="Wpisz rozmiar i naciśnij Enter"
          {...form.getInputProps('availableSizes')}
        />
        <SaleInput mt="md" {...form.getInputProps('isAtSale', { type: 'checkbox' })} />
      </Stack>
    </Form>
  )
}
